import React, { useState, useEffect } from 'react';
import { useForm } from '@mantine/form';
import { TextInput, Button, Group, Title, createStyles, Box, Image, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { saveSupport, updateSupport } from '../../services/api.service';
import { IconCheck } from '@tabler/icons-react';
import ImageDropzone from '../imageDropzone/ImageDropzone';

const useStyles = createStyles((theme) => ({
	imageContainer: {
		border: '1px solid #CCCCCC',
		padding: 3,
		borderRadius: theme.radius.sm,
	}
}));

const SupportForm = ({ closeModal, isEdit, support }) => {
	const [isLoading, toggleLoading] = useState(false);
	const [fileURL, setFileURL] = useState('');
	const [isLogoChanged, toggleIsLogoChanged] = useState(false);
	const [provinces, setProvinces] = useState([]);
	const { classes } = useStyles();

	const form = useForm({
		initialValues: {
		  name: '',
		  file: null,
		},
		validate: {
		  name: (value) => (value ? null : 'Este campo es requerido'),
		  file: (value) => (!isEdit && !value ? 'La imagen es requerida' : null),
		},
	  });
	  

	useEffect(() => {
		if (isEdit) {
			form.setValues({
				name: support.name,
				file: support.file,
			});
		}
		// eslint-disable-next-line
	}, []);

	// Submit form
	const onSubmit = (values) => {
		toggleLoading(true);

		// Conditions
		if (!isEdit) {

			// Call API
			saveSupport(values, function () {
				notifications.show({
					title: 'Apoyante creado correctamente',
					color: 'green',
					icon: <IconCheck />
				});
				setTimeout(() => {
					closeModal();
				}, 1000);

			}, function (error) {
				toggleLoading(false);
				notifications.show({
					title: 'Error',
					message: 'Error inesperado.' || error?.message?.[0],
					color: 'red'
				});

			});

		} else {

			// Call API
			updateSupport(support.id, values, function () {
				notifications.show({
					title: 'Apoyante modificado correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				setTimeout(() => {
					closeModal();
				}, 1000);

			}, function (error) {
				toggleLoading(false);
				notifications.show({
					title: 'Error',
					message: 'Error inesperado.' || error?.message?.[0],
					color: 'red'
				});

			});
		}
	}

	const onDrop = (file) => {
		form.setFieldValue('file', file[0]);
		setFileURL(URL.createObjectURL(file[0]));
		toggleIsLogoChanged(true);
	};

	const onReject = () => {
		notifications.show({
			title: 'Error',
			message: 'Este tipo de archivo no está soportado.',
			color: 'red'
		});
	};

	return (
		<form onSubmit={form.onSubmit(onSubmit)}>
			<Title order={5} mb="md">
				{isEdit ? 'Modificar' : 'Crear'} Información del apoyante
			</Title>

			<Group grow>
				<TextInput
					required
					label="Nombre"
					placeholder="Nombre del apoyante"
					value={form.values.name}
					onChange={(event) => form.setFieldValue('name', event.currentTarget.value)}
					{...form.getInputProps('name')}
				/>
			</Group>

			<Title order={5} mb="md" mt="lg">Imagen <span style={{ color: 'red', fontWeight: '100', lineHeight: '1.5' }}>*</span> </Title>
			<Group>
                <ImageDropzone onDrop={onDrop} onReject={onReject} instruction="Sube la imagen de este apoyante"/>
				{(form.values.file || (isEdit && support.image)) && (
                  <Box className={classes.imageContainer}>
                    <Image
                      withPlaceholder
                      src={
                        isLogoChanged && fileURL
                          ? fileURL
                          : isEdit && support.image
                          ? support.image
                          : undefined
                      }
                      imageProps={
                        isLogoChanged && fileURL
                          ? { onLoad: () => URL.revokeObjectURL(fileURL) }
                          : undefined
                      }
                      height={148}
                      width={148}
                      radius="sm"
                    />
                  </Box>
                )}
			</Group>
			{form.errors.file && (
			  <Text color="red" size="xs" mt={5}>
			    {form.errors.file}
			  </Text>
			)}

			<Group position="apart" grow={!isEdit}>
				<Button
					mt="xl"
					color="red"
					onClick={closeModal}
					disabled={isLoading}
					variant="light"
					sx={{ flexGrow: isEdit ? 2 : 1 }}
				>
					Cancelar
				</Button>
				<Button
					mt="xl"
					type="submit"
					loading={isLoading}
					variant="filled"
					sx={{ flexGrow: isEdit ? 2 : 1 }}
				>
					{isEdit ? 'Guardar Cambios' : 'Crear Apoyante'}
				</Button>
			</Group>
		</form>
	);
};

export default SupportForm;
